import { GET_API } from "./index"

export const getLogServicesApi = async (url, token, dataHeader, dataQuery) => {
  return GET_API(url, token, dataHeader, dataQuery)
}